import React, { Fragment, useContext, useEffect, useState } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Notes from "../../CallInfo/Notes";
import FeedbackTabDetailsSection from "./FeedbackTabDetailsSection";
import ScorecardTemplate from "../../Monitoring/Scorecards/ScorecardTemplate";
import QAFeedbackTabButtons from "../QA/QAFeedbackTabButtons";
import TeamLeaderFeedbackTabButtons from "../TeamLeader/TeamLeaderFeedbackTabButtons";
import QATeamLeaderFeedbackTabButtons from "../QATeamLeader/QATeamLeaderFeedbackTabButtons";
import FeedbackTabButtonsViewModel from "../ViewModels/FeedbackTabButtonsViewModel";
import Box from "@mui/material/Box";
import ScorecardProvider from "../../Contexts/ScorecardContext";

const styles = {
    scroll: {
        overflow: 'auto',
        backgroundColor: '#fff',
        height: '100%',
        padding: '8px'
    }
}

interface IProps {
    view: string;
    callRefId: string;
    setCallRefId: (callRefId: string) => void;
    completeId: number;
    setRescoreCompleteId: (completeId: number) => void;
    close: () => void;
    agentHasResponded?: boolean;
}

export default function FeedbackTab(props: IProps) {
    const { get } = useContext(APIContext);
    const [feedback, setFeedback] = useState<FeedbackTabButtonsViewModel | null>(null);
    const [hasTLQuestions, setHasTLQuestions] = useState<boolean>(false);
    const [allTLQuestionsAnswered, setAllTLQuestionsAnswered] = useState<boolean>(false);

    useEffect(() => {
        getFeedback();
        checkForTLQuestions();
    }, [])

    useEffect(() => {
        checkTLQuestionsAnswered();
    }, [hasTLQuestions])

    const getFeedback = () => {
        get('Feedback', `GetFeedback?completeId=${props.completeId}`, (data) => setFeedback(data));
    }

    const fetchThenUpdate = (controllerAction: string) => {
        get('Feedback', `${controllerAction}?completeId=${props.completeId}`, () => {
            getFeedback();
        })
    }

    const releaseToSelectedAgent = (completeId: number, payrollNumber: number) => {
        get('Feedback', `ReleaseAgentFeedback?completeId=${completeId}&payrollNumber=${payrollNumber}`, () => {
            getFeedback();
        })
    }

    const checkForTLQuestions = () => {
        get('Feedback', `CheckForTeamLeaderQuestions?completeId=${props.completeId}`, (data) => {
            setHasTLQuestions(data);
        })
    }

    const checkTLQuestionsAnswered = () => {
        get('Feedback', `CheckTeamLeaderQuestionsAnswered?completeId=${props.completeId}`, (data) => {
            setAllTLQuestionsAnswered(data);
        })
    }

    return (
        feedback &&
        <Box sx={styles.scroll}>
            <FeedbackTabDetailsSection
                feedback={feedback}
            />
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Paper>
                        <Notes systemPK={props.callRefId} monitoring={true} />
                    </Paper>
                </Grid>
                {
                    props.view === "Team Leader" &&
                    <Fragment>
                        {
                            hasTLQuestions && props.agentHasResponded &&
                            < Grid size={12}>
                                {/* For Team Leader(TL) to answer TL questions on revisit scorecards */}
                                <ScorecardProvider>
                                    <ScorecardTemplate
                                        callRefId={props.callRefId}
                                        scorecardId={props.completeId}
                                        scorecardBuilderView={false}
                                        feedbackView="Team Leader Feedback View"
                                        checkTLQuestionsAnswered={checkTLQuestionsAnswered}
                                    />
                                </ScorecardProvider>
                            </Grid>
                        }
                        <TeamLeaderFeedbackTabButtons
                            feedback={feedback}
                            fetchThenUpdate={fetchThenUpdate}
                            allTeamLeaderQuestionsAnswered={allTLQuestionsAnswered}
                            releaseToSelectedAgent={releaseToSelectedAgent}
                        />
                    </Fragment>
                }
                {
                    props.view === "QA Team Leader" &&
                    <QATeamLeaderFeedbackTabButtons
                        feedback={feedback}
                        getFeedback={getFeedback}
                        setRescoreCompleteId={props.setRescoreCompleteId}
                        close={props.close} />
                }
                {
                    props.view === "QA" &&
                    <QAFeedbackTabButtons
                        feedback={feedback}
                        close={props.close} />
                }
            </Grid>
        </Box>
    );
}